<script setup lang="ts">

</script>

<template>
  <div class="d-flex align-center justify-center">
    <NuxtImg
        src="/images/misc/antonia.png"
        style="max-width: 50px; max-height: 50px; min-width: 40px; min-height: 40px;"
        class="h-100 ma-1 rounded-circle"
        loading="lazy"
        alt="Antonia"
    />
    <div class="font-weight-bold text-contrast">
      Antonia
    </div>
  </div>
</template>

<style scoped>

</style>